import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetWalletTransactionResponseSchema } from "./getWalletTransaction.schema";

export const getWalletTransaction = (axios: IAxiosInstance) => {
  return async (params: { wallet_transaction_id: string }) => {
    const { wallet_transaction_id } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetWalletTransactionResponseSchema>
    >(`/api/wallet-transactions/${wallet_transaction_id}`);

    return response.data;
  };
};
